import React, { useState } from 'react';
const LensPowerCalculator = () => {
  const [focalLength, setFocalLength] = useState('');
  const [lensPower, setLensPower] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');
  const handleCalculate = () => {
    if (!focalLength) {
      setError('الرجاء إدخال البعد البؤري (F)');
      setLensPower('');
      setExplanation('');
      return;
    }
    const focalLengthValue = parseFloat(focalLength);
    if (isNaN(focalLengthValue)) {
      setError('الرجاء إدخال قيمة بعد بؤري صحيحة');
      setLensPower('');
      setExplanation('');
      return;
    }
    const lensPowerValue = 1 / focalLengthValue;
    setLensPower(lensPowerValue.toFixed(2));
    const lensType = lensPowerValue > 0 ? 'عدسة محدبة' : 'عدسة مقعرة';
    setExplanation(
      `قوة العدسة (C) = 1 / البعد البؤري (F) = 1 / ${focalLengthValue} = ${lensPowerValue.toFixed(2)}\n\n` +
      `نظرًا لأن قوة العدسة موجبة (+)، إذا كانت هذه العدسة ${lensType}.`
    );
    setError('');
  };
  return (
    <div dir="rtl">
      <div>
        <input
          type="number"
          placeholder="البعد البؤري (F)"
          value={focalLength}
          onChange={(e) => setFocalLength(e.target.value)}
          className="form-control"
          style={{ width: '75%' }}
        />
        <br/>
        <button
          className="btn btn-success"
          style={{ fontSize: '20px' }}
          onClick={handleCalculate}
        >
          احسب قوة العدسة
        </button>
      </div>
      <br />
      <div>
        {error !== '' ? (
          <p className='p-3 mb-2 bg-warning text-white'>خطأ: {error}</p>
        ) : (
          <>
            {lensPower !== '' && (
              <>
                <p className='p-3 mb-2 bg-success text-white'>
                  قوة العدسة (C): {lensPower}
                </p>
                {explanation !== '' && (
                  <p className='p-3 mb-2 bg-info text-black'>
                    خطوات الحل: <br/>{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default LensPowerCalculator;
